<template>
  <div class="app-page">
    <div class="application-page-header">
      <div class="page-title">{{ $t('user.' + $route.meta?.title) }}</div>
      <div class="page-remark" v-if="offlineMode">
         {{ $t('user.This Session is Offline') }}
      </div>
      <div class="page-remark" v-else>
        <calendar-outlined />
        <span>
          {{ $t('user.Application Approval Due Date') }}:
          {{ applicationApprovalPeriod[1] }}
        </span>
      </div>
    </div>
    <div class="application-page-container">
      <div class="application-page-panel">
        <div class="counts">
          <label>{{ $t('user.Eligible Applicant') }}</label>
          <span>{{ eligibleApplicationCount }}</span>
          <label>{{ $t('user.Applied Applicant') }}</label>
          <span>{{ appliedApplicationCount }}</span>
        </div>
        <div>
          <a-button
            class="download-assessment-button"
            @click="exportData"
            :disabled="selectedRowKeys.length == 0"
          >
            {{ $t('user.Download Assessment') }}
          </a-button>
          <span>
            {{ $t('user.Selected') }} {{ selectedRowKeys.length }}
            {{ $t('user.items') }}
          </span>
        </div>
      </div>

      <a-table
        class="job-table"
        :rowKey="(record) => record.employee_id"
        :columns="columns"
        :data-source="applicationRecord"
        :pagination="false"
        :row-selection="{
          selectedRowKeys,
          getCheckboxProps,
          onChange: onSelectChange,
        }"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>

        <template v-slot:headerCell="{ title, _ }">
            {{ $t('user.' + title) }}
        </template>

        <template v-slot:bodyCell="{ text, record, column }">
          <template v-if="column.key === 'result'">
            <ApplyStatusColumn :data="record" />
          </template>
          <template v-else-if="column.key === 'action'">
            <router-link
              :to="{ path: `/teams/detail/${record.id}` }"
              v-if="record.status != 0 && record.status != 10"
            >
              <a-button type="link">
                {{
                  record.can_operation
                    ? $t('user.Review and Evaluate')
                    : $t('user.View')
                }}
              </a-button>
            </router-link>
          </template>
          <template v-else>
            <span v-if="record.status == 0" style="color: #999">
              {{ text }}
            </span>
            <span v-else>{{ text }}</span>
          </template>
        </template>
      </a-table>
      <div class="page-pagination">
        <a-pagination
          @change="fetchData"
          v-model:current="pagination.current"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          size="small"
          show-less-items
          show-size-changer
          show-quick-jumper
        />
      </div>
    </div>
    <a-modal
      v-model:visible="downloadVisible"
      centered
      :title="$t('user.Download assessment')"
      :maskClosable="false"
      width="480px"
      :footer="null"
    >
      <p>
        {{
          $t(
            'user.Please click to choose which type of assessment you want. Once the file is ready, a download link will be sent to your Publicis mailbox'
          )
        }}
      </p>
      <div class="download-assessment-buttons">
        <a-button
          class="download-assessment-button"
          @click="downloadLatestAssessment"
        >
          {{ $t('user.Download latest assessment') }}
        </a-button>
        <a-button
          class="download-assessment-button"
          @click="downloadAllAssessment"
        >
          {{ $t('user.Download all assessment') }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { getTeamsApplicationRecord, assessExport } from '@/api/index'
  import { mapGetters } from 'vuex'
  import { CalendarOutlined } from '@ant-design/icons-vue'
  import { ApplyStatusColumn } from '@/components/ApplyStatus/index.js'
  import Empty from '@/components/Empty'
  import bus from '@/lib/bus'

  export default {
    name: 'Index',
    components: {
      CalendarOutlined,
      ApplyStatusColumn,
      Empty,
    },
    data() {
      return {
        title: 'My Team Applications',
        downloadVisible: false,
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['2', '10', '30', '50'],
        },
        columns: [
          {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
          },
          {
            title: 'Current Role',
            key: 'current',
            dataIndex: 'current',
          },
          {
            title: 'Target Role',
            key: 'target',
            dataIndex: 'target',
          },
          {
            title: 'Panel Result',
            key: 'result',
            dataIndex: 'result',
          },
          {
            title: 'Action',
            key: 'action',
            dataIndex: 'action',
          },
        ],
        applicationRecord: [],
        selectedRowKeys: [],
        allSelectedRowKeys: [],
        numberOfApplicants: 0,
        numberOfTotalTalents: 0,
      }
    },

    computed: {
      ...mapGetters({
        applicationApprovalPeriod: 'user/applicationApprovalPeriod',
        Authorization: 'user/accessToken',
        offlineMode: 'user/offlineMode',
      }),
      eligibleApplicationCount() {
        return this.numberOfTotalTalents
        // return this.applicationRecord.length
      },
      appliedApplicationCount() {
        // console.log(this.applicationRecord)
        // return this.applicationRecord.filter((item) => {
        //   return item.status !== 0
        // }).length
        return this.numberOfApplicants
      },
    },
    mounted() {
      this.title = this.$route.meta?.title
      // getTeamsApplicationRecord().then((res) => {
      //   this.applicationRecord = res.data
      // })
      this.fetchData()
    },
    methods: {
      fetchData() {
        const params = {
          pageSize: this.pagination.pageSize || 10,
          pageNum: this.pagination.current || 1,
          pagination: this.pagination,
        }
        this.loading = true
        return getTeamsApplicationRecord(params)
          .then((res) => {
            if (res.code == 200) {
              this.pagination.total = res.page.total || 0
              this.applicationRecord = res.data
              this.numberOfApplicants = res.info.NumberOfApplicants
              this.numberOfTotalTalents = res.info.NumberOfTotalTalents
            }
            return res
          })
          .finally(() => {
            this.loading = false
          })
      },
      onSelectChange(selectedRowKeys) {
        this.allSelectedRowKeys[this.pagination.current] = selectedRowKeys
        this.selectedRowKeys = this.allSelectedRowKeys
          .filter((item) => item != null)
          .flatMap((item) => item)
      },
      getCheckboxProps: (record) => ({}),
      exportData() {
        this.downloadVisible = true
      },
      downloadLatestAssessment() {
        const that = this
        assessExport(this.Authorization, this.selectedRowKeys, true).then(
          (msg) => {
            this.downloadVisible = false
            setTimeout(() => {
              bus.emit('fetchMsg')
            }, Math.floor(Math.random() * 3 + 3) * 1000)
            // const fileDesc = msg.headers['content-disposition']
            // const fileName = fileDesc.substr(fileDesc.indexOf('filename') + 10)
            // const file = new Blob([msg.data])
            // const reader = new FileReader()
            // reader.readAsDataURL(file)
            // reader.onload = (e) => {
            //   var link = document.createElement('a')
            //   link.style.display = 'none'
            //   link.href = e.target.result
            //   link.download = fileName
            //   var body = document.querySelector('body')
            //   body.appendChild(link)
            //   link.click()
            //   body.removeChild(link)
            //   window.URL.revokeObjectURL(link.href)
            // }
          }
        )
      },
      downloadAllAssessment() {
        const that = this
        assessExport(this.Authorization, this.selectedRowKeys).then((msg) => {
          this.downloadVisible = false
          setTimeout(() => {
            bus.emit('fetchMsg')
          }, Math.floor(Math.random() * 3 + 3) * 1000)

          // const fileDesc = msg.headers['content-disposition']
          // const fileName = fileDesc.substr(fileDesc.indexOf('filename') + 10)
          // const file = new Blob([msg.data])
          // const reader = new FileReader()
          // reader.readAsDataURL(file)
          // reader.onload = (e) => {
          //   var link = document.createElement('a')
          //   link.style.display = 'none'
          //   link.href = e.target.result
          //   link.download = fileName
          //   var body = document.querySelector('body')
          //   body.appendChild(link)
          //   link.click()
          //   body.removeChild(link)
          //   window.URL.revokeObjectURL(link.href)
          // }
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');
  .application-page-header {
    background-color: white;
    padding: 32px 32px;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .page-title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }

    .application-counter {
      margin-top: 8px;
      display: flex;
      align-items: center;
      .item-counter {
        margin-right: 50px;
      }
    }
  }
  .application-page-container {
    margin: @app-conetent-margin;
    background-color: white;
    padding: 20px 24px;

    .application-page-panel {
      .counts {
        & > :nth-child(2) {
          margin-right: 20px;
        }
      }

      & > div {
        margin-bottom: 20px;
      }

      label {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;

        &::after {
          content: ':';
          margin: 0 8px 0 2px;
          position: relative;
          top: -0.5px;
        }
      }

      .download-assessment-button {
        margin-right: 20px;
      }
    }
  }

  .download-assessment-buttons {
    display: flex;
    justify-content: space-between;
  }

  :deep {
    .table-pagination,
    .page-pagination {
      margin: 20px 0;
      display: flex;
      justify-content: flex-end;
      .ant-pagination-item-active {
        a {
          color: white;
        }
        background-color: @primary-color;
      }
    }
  }
</style>
